import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM12 6C10.1481 6 8.53257 7.00738 7.66955 8.49927L7.16883 9.36488L8.90004 10.3663L9.40076 9.50073C9.92099 8.60142 10.8909 8 12 8C13.1092 8 14.0791 8.60141 14.5993 9.50073L15.1 10.3663L16.8312 9.36488L16.3305 8.49927C15.4675 7.00738 13.852 6 12 6ZM9 16V12H7V16H9ZM17 16V12H15V16H17Z"}}]};

const FlipSmilingFaceFilled = Vue.extend<IconProps>({
  name: 'FlipSmilingFaceFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'flip-smiling-face-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FlipSmilingFaceFilled;
